import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ spacing }) => ({
    box: {
        margin: spacing(0, 0.5),
    },
}));
function Container({ children, type = 'box', }) {
    const classes = useStyles();
    return React.createElement("div", { className: classNames(classes[type]) }, children);
}
export default Container;
//# sourceMappingURL=Container.js.map